import { MutableRefObject, memo } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DisplayTimingGroupListItem } from '../models';
import DisplayTimingGroupRow from './DisplayTimingGroupRow';

interface DisplayTimingGroupTableProps {
  data: DisplayTimingGroupListItem[];
  arrChkSelectRef: MutableRefObject<HTMLInputElement[]>;
  onSelectRow?: () => void;
  onReorder?: (rows: DisplayTimingGroupListItem[]) => void;
  onReloadData?: () => void;
}

function DisplayTimingGroupTable({
  data,
  arrChkSelectRef,
  onSelectRow,
  onReorder,
  onReloadData,
}: DisplayTimingGroupTableProps) {
  const { t } = useTranslation();

  //ref
  // const arrChkSelectRef = useRef<Array<HTMLInputElement>>([]);

  function handleMove(index: number, targetIndex: number) {
    if (targetIndex < 0 || targetIndex >= data.length) return;

    const newRows = [...data];
    const tempSortOrder = newRows[index].sort_order;
    newRows[index] = { ...newRows[index], sort_order: newRows[targetIndex].sort_order };
    newRows[targetIndex] = { ...newRows[targetIndex], sort_order: tempSortOrder };

    newRows.sort((a, b) => a.sort_order - b.sort_order);

    onReorder?.(newRows);
  }

  // function getSelectedElements() {
  //   return arrChkSelectRef.current.filter((elem) => elem && elem.checked);
  // }

  function handleSelectRow(event: React.ChangeEvent<HTMLInputElement>) {
    // const checkedElements = getSelectedElements();
    onSelectRow?.();
  }

  return (
    <>
      <div className="sticky-table flex-grow-1 flex-shrink-1">
        <Table hover>
          <thead>
            <tr>
              <th style={{ width: '4%' }}>{t('DisplayTimingGroup.selection')}</th>
              <th style={{ width: '4%' }}>{t('DisplayTimingGroup.display_order')}</th>
              <th style={{ width: '8%' }}>{t('DisplayTimingGroup.order_change')}</th>
              <th style={{ width: '18%' }}>{t('DisplayTimingGroup.group_name')}</th>
              <th style={{ width: '8%' }}>{t('DisplayTimingGroup.status')}</th>
              <th style={{ width: '12%' }}>{t('DisplayTimingGroup.week_range')}</th>
              <th style={{ width: '18%' }}>{t('DisplayTimingGroup.date_range')}</th>
              <th style={{ width: '12%' }}>{t('DisplayTimingGroup.time_range')}</th>
              <th style={{ width: '10%' }}>{t('DisplayTimingGroup.target_menu')}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <DisplayTimingGroupRow
                key={item.id}
                item={item}
                index={index}
                isFirst={index === 0}
                isLast={index === data.length - 1}
                groups={data}
                onMove={handleMove}
                onSelectRow={handleSelectRow}
                checkboxRef={(el) => {
                  arrChkSelectRef.current[index] = el;
                }}
                onReloadData={onReloadData}
              />
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default memo(DisplayTimingGroupTable);
